export enum HttpHeaders {
  AUTHORIZATION = 'Authorization',
  CONTENT_TYPE = 'Content-Type',
  X_API_KEY = 'X-Api-Key',
  X_SDK_VERSION = 'X-SDK-Version',
}

export const basicAuthHeader = (username: string, password: string) =>
  `Basic ` + Buffer.from(`${username}:${password}`).toString('base64')

export const bearerAuthHeader = (token: string) => `Bearer ${token}`
